import { build as buildSearchProductsFromBrandFilters } from "@faire/web-api/api/v2/search/products/from-brand/filters/post";
import { build as buildSearchProductsFromBrand } from "@faire/web-api/api/v2/search/products/from-brand/post";
import { ISearchBrandProductsFiltersRequest } from "@faire/web-api/indigofair/data/ISearchBrandProductsFiltersRequest";
import { ISearchMakerProductsRequest } from "@faire/web-api/indigofair/data/ISearchMakerProductsRequest";
import { ISearchProductsFromBrandRequest } from "@faire/web-api/indigofair/data/ISearchProductsFromBrandRequest";
import { QueryParameters as BrandPageQueryParameters } from "@faire/web-api/routes/brand/brandToken";

import { LOGGED_OUT_BRAND_PRODUCTS_PAGE_SIZE } from "./consts";

// Utility function to build the API request for from-brand for the logged-out brand page.
export const buildBrandLeanProductTilesRequest = (params: {
  brandToken: string;
  search: string;
}) => {
  const { brandToken, search } = params;
  const { filters, refP } = BrandPageQueryParameters.parse(search);

  return buildSearchProductsFromBrand(
    brandLeanProductTilesRequest({
      brandToken,
      filters,
      refP,
      pageSize: LOGGED_OUT_BRAND_PRODUCTS_PAGE_SIZE,
    })
  );
};

export const buildSearchProductsFromBrandFilterRequest = (
  brandToken: string
) => {
  return buildSearchProductsFromBrandFilters(
    brandSearchProductsFromBrandFilters(brandToken)
  );
};

export const brandLeanProductTilesRequest = (params: {
  brandToken: string;
  filters: string | undefined;
  refP: string | undefined;
  pageSize: number | undefined;
}) => {
  return ISearchProductsFromBrandRequest.build({
    brand_token: params.brandToken,
    page_size: params.pageSize,
    sort_by: ISearchMakerProductsRequest.SortBy.FEATURED,
    filter_keys: params.filters ? [params.filters] : [],
    ranking_boost: params.refP
      ? ISearchMakerProductsRequest.IRankingBoost.build({
          referrer_products: [params.refP],
        })
      : undefined,
  });
};

export const brandSearchProductsFromBrandFilters = (brandToken: string) => {
  return ISearchBrandProductsFiltersRequest.build({
    /**
     * We intentionally don't include `filter_keys` and `query` in this request
     * because logged-out brand only supports "CATEGORY" filters.
     * See `categoryFilterOptions` in `FilterTabs` for usage.
     **/
    brand_token: brandToken,
  });
};
